import { render, staticRenderFns } from "./EvaluationMenu.vue?vue&type=template&id=39cc2510"
import script from "./EvaluationMenu.vue?vue&type=script&lang=js"
export * from "./EvaluationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports